var _excluded = ["children"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useRef, forwardRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useForwardedRef, useInstanceId } from '@adsk/alloy-react-helpers';
import { stylePropType } from '@adsk/alloy-react-theme';
import NestableTreeNode from './NestableTreeNode';
var NestableTreeUl = styled.ul.attrs(function (p) {
  return _objectSpread(_objectSpread({}, p), {}, {
    role: 'tree'
  });
}).withConfig({
  displayName: "NestableTree__NestableTreeUl",
  componentId: "sc-5q3ug9-0"
})(["display:flex;flex-flow:column nowrap;width:250px;padding:0;"]);
var NestableTree = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var ref = useForwardedRef(forwardedRef);
  var firstChildRef = useRef(null);
  var treeId = useInstanceId();
  useEffect(function () {
    if (firstChildRef.current) {
      firstChildRef.current.focus();
    }
  }, [firstChildRef]);
  return /*#__PURE__*/React.createElement(NestableTreeUl, _extends({
    ref: ref,
    id: treeId
  }, props), React.Children.map(children, function (child, index) {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      if (index === 0) {
        return /*#__PURE__*/React.cloneElement(child, {
          ref: firstChildRef,
          treeId: treeId
        });
      }
      return /*#__PURE__*/React.cloneElement(child, {
        treeId: treeId
      });
    }
    return child;
  }));
});
NestableTree.displayName = 'NestableTree';
NestableTree.propTypes = {
  /* style object to add to the tree root */
  style: stylePropType,
  /* Tree nodes */
  children: PropTypes.node
};
export default Object.assign(NestableTree, {
  Node: NestableTreeNode
});
//# sourceMappingURL=NestableTree.js.map